export class AdminSubscriptionCompanyCourier {
  courierId: string

  name: string

  email: string

  phone: string

  vehicleType: string

  status: string

  deliveriesCount: number

  constructor(data: Partial<AdminSubscriptionCompanyCourier> = {}) {
    this.courierId = data.courierId ?? ""

    this.name = data.name ?? ""

    this.email = data.email ?? ""

    this.phone = data.phone ?? ""

    this.vehicleType = data.vehicleType ?? ""

    this.status = data.status ?? ""

    this.deliveriesCount = data.deliveriesCount ?? 0
  }
}
